import "./GalleryLayout.css";
import { useState, useEffect, useRef } from "react";
import { Button, Accordion, Offcanvas, Modal, Form, Dropdown } from "react-bootstrap";
import { DateRange, DateRangePicker } from "react-date-range";
import { addDays } from "date-fns";
import ListView from "./ListView";
import GridView from "./GridView";
import Instance from "../../Utils/Axios";
import { showToast } from "../../Utils/index";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import axios from "axios";
import PremiumLoader from "../Loader/PremiumLoader";
const BASE_URL = "https://pr.webandapi.com";

export default function GalleryLayout() {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [filtersApplied, setFiltersApplied] = useState(0);
  const [filters, setFilters] = useState({
    createdOn: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [appliedFilters, setAppliedFilters] = useState({
    createdOn: null,
  });
  const [gridView, setGridView] = useState(() => {
    const saved = localStorage.getItem("gallery_grid_view");
    return saved !== null ? JSON.parse(saved) : false;
  });
  const [showUpload, setShowUpload] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [checkedState, setCheckedState] = useState([]);
  const [images, setImages] = useState([]);
  const [uploadImage, setUploadImage] = useState({
    documentUrl: '',
    name: '',
    alternateText: '',
    size: 0,
  });
  const [imageDescription, setImageDescription] = useState({});
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [numSelectedCheckboxes, setNumSelectedCheckboxes] = useState(0);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedFilePath, setSelectedFilePath] = useState("");
  const fileInputRef = useRef(null);
  const galleryRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const today = new Date();
  const lastMonth = new Date();
  lastMonth.setDate(today.getDate() - 30);

  const [selectionRange, setSelectionRange] = useState({
    startDate: today,
    endDate: today,
    key: "selection",
  });
  const [activeQuickRange, setActiveQuickRange] = useState("");
  const [isDateFilterApplied, setIsDateFilterApplied] = useState(false);

  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    const normalized =
      typeof dateString === "string" ? dateString.replace(" ", "T") : dateString;
    const date = new Date(normalized);
    if (Number.isNaN(date.getTime())) return dateString;

    const dateFormatter = new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });

    const timeFormatter = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    return `${dateFormatter.format(date)} • ${timeFormatter.format(date)}`;
  };

  const isImageFile = (url) => {
    if (!url) return false;
    const extension = url.split(".").pop().toLowerCase();
    return ["jpg", "jpeg", "png", "webp", "bmp"].includes(extension);
  };

  const isOfficeFile = (url) => {
    if (!url) return false;
    const extension = url.split(".").pop().toLowerCase();
    const officeExtensions = [
      "pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv", "rtf"
    ];
    return officeExtensions.includes(extension);
  };

  const handleSelect = (ranges) => {
    setSelectionRange({
      ...ranges.selection,
      key: "selection"
    });
    setActiveQuickRange("");
    setIsDateFilterApplied(true);
  };

  const handleQuickSelect = (type) => {
    const today = new Date();
    let start = today;
    let end = today;

    switch (type) {
      case "Today":
        break;
      case "Yesterday":
        start = addDays(today, -1);
        end = addDays(today, -1);
        break;
      case "This Week":
        start = addDays(today, -today.getDay());
        break;
      case "Last Week":
        start = addDays(today, -today.getDay() - 7);
        end = addDays(today, -today.getDay() - 1);
        break;
      case "This Month":
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        break;
      case "Last Month":
        start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        end = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      default:
        break;
    }

    setSelectionRange({
      startDate: start,
      endDate: end,
      key: "selection",
    });
    setActiveQuickRange(type);
    setIsDateFilterApplied(true);
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const updatedCheckedState = new Array(images.length).fill(isChecked);
    setCheckedState(updatedCheckedState);
    setNumSelectedCheckboxes(isChecked ? images.length : 0);
    if (images.length > 0 && isChecked) {
      setSelectedPhoto(images[0].imgUrl || images[0].documentUrl);
      fetchImagesDetails(images[0].galleryId);
    }
  };

  useEffect(() => {
    const fetchPaginatedImages = async () => {
      setLoading(true);
      // const token = localStorage.getItem("tokenId");
      let payload = {};
      if (!gridView) {
        payload = {
          pageNumber: currentPage,
          pageSize: rowsPerPage,
        };

        if (sortConfig.key) {
          payload.orderBy = sortConfig.key;
          payload.orderByType = sortConfig.direction === "ascending" ? "ASC" : "DESC";
        }

        if (appliedFilters.createdOn) {
          payload.fromDate = appliedFilters.createdOn.startDate;
          payload.toDate = appliedFilters.createdOn.endDate;
        }
      }

      try {
        const response = await Instance.post("/user/gallery/getList", payload);
        if (response.data.resCode === "200") {
          const fetchedImages = response.data.message || [];
          setImages(fetchedImages);

          const newCheckedState = new Array(fetchedImages.length).fill(false);
          if (fetchedImages.length > 0) {
            newCheckedState[0] = true;
            setNumSelectedCheckboxes(1);
            Instance.post("user/gallery/details", { galleryId: fetchedImages[0].galleryId })
              .then((detailRes) => {
                if (detailRes.data.resCode === "200") {
                  setImageDescription(detailRes.data.message);
                  setSelectedPhoto(detailRes.data.message.imgUrl || detailRes.data.message.documentUrl);
                }
              })
              .catch(err => console.error("Error fetching first image details:", err));
          } else {
            setSelectedPhoto(null);
            setNumSelectedCheckboxes(0);
          }

          setCheckedState(newCheckedState);
          setTotalPages(response.data.totalPages || 1);
          setTotalRecords(response.data.totalRecords || response.data.totalRecord || 0);
        } else {
          setImages([]);
          setCheckedState([]);
          setTotalPages(1);
          setTotalRecords(0);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPaginatedImages();
  }, [currentPage, rowsPerPage, sortConfig, appliedFilters, gridView]);
  const fetchImagesDetails = (imageId) => {
    setDetailsLoading(true);
    // const token = localStorage.getItem("tokenId");
    Instance
      .post("user/gallery/details", {
        // tokenId: token,
        galleryId: imageId,
      })
      .then((response) => {
        if (response.data.resCode === "200") {
          setImageDescription(response.data.message);
          setSelectedPhoto(response.data.message.imgUrl || response.data.message.documentUrl);
        }
      })
      .catch((error) => {
        console.error("Error fetching image details:", error);
      })
      .finally(() => {
        setDetailsLoading(false);
      });
  };

  const handlePhotoClick = (galleryId) => {
    fetchImagesDetails(galleryId);
  };

  const handleDelete = (galleryId) => {
    const token = localStorage.getItem("tokenId");
    Instance.post("/user/gallery/update", {
      // tokenId: token,
      galleryId: galleryId,
      status: "INACTIVE",
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          // console.log("deleted");
          showToast("Image Deleted successfully!", "success", "succes");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          // console.log("could delete");
        }
      })
      .catch((error) => {
        console.error("Error fetching image details:", error);
      });
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleShowUpload = () => {
    setShowUpload(true);
  };
  const handleNotShowUpload = () => {
    setShowUpload(false);
  };

  const handleShowDelete = () => {
    setShowDelete(true);
  };
  const hadnleNotShowDelete = () => {
    setShowDelete(false);
  };

  const handleShowPreview = () => {
    setShowPreview(true);
  };
  const handleNotShowPreview = () => {
    setShowPreview(false);
  };

  const handleListView = () => {
    setGridView(false);
    localStorage.setItem("gallery_grid_view", JSON.stringify(false));
  };
  const handleGridView = () => {
    setGridView(true);
    localStorage.setItem("gallery_grid_view", JSON.stringify(true));
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const calculateFiltersApplied = () => {
    let count = 0;
    if (isDateFilterApplied) count++;
    setFiltersApplied(count);
  };
  // const handleApplyFilters = () => {
  //   calculateFiltersApplied();
  //   handleClose();
  // };

  const handleApplyFilters = () => {
    calculateFiltersApplied();
    handleClose();
    setCurrentPage(1);

    setAppliedFilters({
      createdOn: isDateFilterApplied && selectionRange.startDate && selectionRange.endDate
        ? {
          startDate: selectionRange.startDate.toISOString().split("T")[0],
          endDate: selectionRange.endDate.toISOString().split("T")[0],
        }
        : null,
    });
  };

  const handleClearFilters = () => {
    setFiltersApplied(0);
    const today = new Date();
    setSelectionRange({
      startDate: today,
      endDate: today,
      key: "selection",
    });
    setActiveQuickRange("");
    setIsDateFilterApplied(false);

    setCurrentPage(1);
    setAppliedFilters({ createdOn: null });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  // const handleClearFilters = () => {
  //   setSelectedDate(null);
  //   setFiltersApplied(0);
  // };

  const handleSelectionCountChange = (count) => {
    setNumSelectedCheckboxes(count);
  };

  const updateSelectedCheckboxes = (updatedCheckedState) => {
    // setNumSelectedCheckboxes((prevCount) => prevCount + 1);
    setCheckedState(updatedCheckedState);
  };

  const copyURL = async (url) => {
    const textToCopy = typeof url === "string" ? url : String(url ?? "");
    if (!textToCopy) {
      showToast("Nothing to copy.", "error", "error");
      return;
    }

    try {
      const clipboard =
        typeof navigator !== "undefined" ? navigator.clipboard : undefined;
      if (clipboard && typeof clipboard.writeText === "function") {
        await clipboard.writeText(textToCopy);
        showToast("URL copied!", "success", "success");
        return;
      }

      if (typeof document === "undefined") {
        showToast("Copy is not available.", "error", "error");
        return;
      }

      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      textArea.setAttribute("readonly", "");
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "-9999px";
      document.body.appendChild(textArea);
      textArea.select();
      textArea.setSelectionRange(0, textToCopy.length);

      const copied = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (copied) {
        showToast("URL copied!", "success", "success");
      } else {
        showToast("Copy failed. Please copy manually.", "error", "error");
      }
    } catch {
      showToast("Copy failed. Please copy manually.", "error", "error");
    }
  };

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setSelectedFileName(file.name);
  //     setSelectedFilePath(URL.createObjectURL(file));
  //     console.log(URL.createObjectURL(file));
  //   }
  // };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/msword",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!allowedTypes.includes(file.type)) {
      showToast("Invalid file type. Please upload JPG, PNG, WEBP, PDF, XLS, or XLSX.", "danger", "error");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    if (file.size > maxSize) {
      showToast("File size exceeds 5MB limit.", "danger", "error");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    setUploadImage(prev => ({
      ...prev,
      name: file.name,
      size: file.size
    }));
    setSelectedFile(file);
  };

  const handleUpload = () => {
    if (!selectedFile) {
      showToast("Please choose a file first.", "danger", "error");
      return;
    }

    setLoading(true);
    const formDataToSubmit = new FormData();
    formDataToSubmit.append("fileUpload", selectedFile);

    // Step 1: Upload the file to document server
    axios
      .post("/site/upload/documents", formDataToSubmit, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((uploadRes) => {
        if (uploadRes?.data?.resCode == "200") {
          const documentUrl = uploadRes.data.documentUrl;

          // Step 2: Create the gallery entry
          Instance.post("/user/gallery/create", {
            name: uploadImage.name,
            documentUrl: documentUrl,
            alternateText: uploadImage.alternateText,
            size: uploadImage.size,
          })
            .then((res) => {
              if (res.data.resCode === "200") {
                showToast(res.data.resMessage, "success", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              } else {
                showToast("Failed to create gallery entry.", "danger", "error");
              }
            })
            .catch((err) => {
              console.error("Error saving to gallery:", err);
              showToast("Error saving to gallery.", "danger", "error");
            })
            .finally(() => setLoading(false));
        } else {
          showToast(uploadRes?.data?.resMessage || "Upload failed.", "danger", "error");
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        showToast("Error uploading file.", "danger", "error");
        setLoading(false);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUploadImage({
      ...uploadImage,
      [name]: value,
    });
  };
  // console.log("images", images)

  return (
    <>
      {loading ? (
        <div className="text-center py-5 d-flex align-items-center justify-content-center" style={{ minHeight: '400px' }}>
          <PremiumLoader fullPage={false} text="Managing your media gallery..." />
        </div>
      ) : (
        <div className="gallery_layout" style={!gridView ? { height: "auto", overflow: "visible" } : {}}>
          <div className={`all_images ${images.length === 0 ? "w-100" : ""}`} style={!gridView ? { height: "auto", overflow: "visible" } : {}}>
            <div className="gallery_options_btns">
              <div className="d-flex align-items-center">
                <button
                  className="grid_view_btn"
                  onClick={handleGridView}
                  style={{
                    backgroundColor: gridView === false ? "#5D6B82" : "#585EDB",
                  }}
                >
                  <img
                    className=""
                    src="/build/img/Icons/Grid.svg"
                    alt="zex pr wire Logo"
                    width={16}
                    height={16}

                  />
                </button>
                <button
                  className="list_view_btn"
                  onClick={handleListView}
                  style={{
                    backgroundColor: gridView === true ? "#5D6B82" : "#585EDB",
                  }}
                >
                  <img
                    className=""
                    src="/build/img/Icons/List.svg"
                    alt="zex pr wire Logo"
                    width={16}
                    height={16}

                  />
                </button>
                <div className=" d-flex align-items-center gap-2">
                  <Button
                    variant="primary"
                    className="Payment_filter_btn"
                    onClick={handleShow}
                  >
                    Filter
                    <img
                      className="filter_img"
                      src="/build/img/Icons/down_vector.svg"
                      alt="zex pr wire Logo"
                      width={16}
                      height={16}

                    />
                  </Button>
                  <Offcanvas show={show} onHide={handleClose} placement="start" className="filter_offcanvas">
                    <Offcanvas.Header closeButton className="filter_offcanvas_header">
                      <Offcanvas.Title className="filter_offcanvas_title">
                        {filtersApplied} filters applied
                      </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body className="filter_offcanavas_body">
                      <Accordion alwaysOpen flush>
                        <Accordion.Item eventKey="0" className="accordian_item">
                          <Accordion.Header className="filter_accordian">
                            Date Range
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="quick_ranges_container">
                              {["Today", "Yesterday", "This Week", "Last Week", "This Month", "Last Month"].map((label) => (
                                <button
                                  key={label}
                                  className={`quick_range_btn ${activeQuickRange === label ? "active" : ""}`}
                                  onClick={() => handleQuickSelect(label)}
                                >
                                  {label}
                                </button>
                              ))}
                            </div>
                            <div className="date_picker_container">
                              <DateRange
                                ranges={[selectionRange]}
                                onChange={handleSelect}
                                months={1}
                                direction="horizontal"
                                maxDate={new Date()}
                                showMonthAndYearPickers={true}
                                moveRangeOnFirstSelection={false}
                                navigatorRenderer={(focusedDate, changeShownDate) => {
                                  const months = [
                                    "January", "February", "March", "April", "May", "June",
                                    "July", "August", "September", "October", "November", "December"
                                  ];
                                  const currentYear = new Date().getFullYear();
                                  const years = Array.from({ length: 50 }, (_, i) => currentYear - 25 + i);

                                  return (
                                    <div className="rdrMonthAndYearPickers custom_nav_pickers">
                                      <div className="calendar_nav_wrapper">
                                        <Dropdown onSelect={(m) => changeShownDate(new Date(focusedDate.setMonth(parseInt(m))))}>
                                          <Dropdown.Toggle variant="light" className="calendar_nav_btn">
                                            {months[focusedDate.getMonth()]}
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu className="calendar_nav_menu scrollable_menu">
                                            {months.map((m, i) => (
                                              <Dropdown.Item key={m} eventKey={i}>{m}</Dropdown.Item>
                                            ))}
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>

                                      <div className="calendar_nav_wrapper">
                                        <Dropdown onSelect={(y) => changeShownDate(new Date(focusedDate.setFullYear(parseInt(y))))}>
                                          <Dropdown.Toggle variant="light" className="calendar_nav_btn">
                                            {focusedDate.getFullYear()}
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu className="calendar_nav_menu scrollable_menu">
                                            {years.map((y) => (
                                              <Dropdown.Item key={y} eventKey={y}>{y}</Dropdown.Item>
                                            ))}
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>
                                    </div>
                                  );
                                }}
                              />
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                      <div className="mt-4 mb-4 filter_btns">
                        <button
                          className="filter_clear_btn"
                          onClick={handleClearFilters}
                        >
                          Clear
                        </button>
                        <button
                          className="filter_apply_btn"
                          onClick={handleApplyFilters}
                        >
                          Apply
                        </button>
                      </div>
                    </Offcanvas.Body>
                  </Offcanvas>
                  <div className="d-flex align-items-center flex-wrap ms-2 gap-2">
                    {filtersApplied > 0 && (
                      <div className="d-flex align-items-center border rounded-pill px-3 py-1" style={{ fontSize: '13px', color: '#d9534f', borderColor: '#d9534f', backgroundColor: '#fdf2f2' }}>
                        <span className="me-2 fw-medium">
                          {filtersApplied} filters applied
                        </span>
                        <span
                          aria-hidden="true"
                          style={{ cursor: "pointer", fontSize: "18px", lineHeight: "1", marginLeft: "4px" }}
                          onClick={handleClearFilters}
                        >
                          &times;
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="select_all_container">
                  <Form.Check
                    type="checkbox"
                    label="Select all"
                    id="select_all_checkbox"
                    onChange={handleSelectAll}
                    checked={images.length > 0 && checkedState.every(val => val === true)}
                  />
                </div>
                <button className="upload_gallery_btn" onClick={handleShowUpload}>
                  <img
                    className="upload_gallery_img"
                    src="/build/img/Icons/Upload.svg"
                    alt="zex pr wire Logo"
                    width={16}
                    height={16}

                  />
                  Upload
                </button>
                <Modal
                  show={showUpload}
                  onHide={handleNotShowUpload}
                  centered
                  className="gallery_modal custom_modal_upload"
                >
                  <Modal.Body className="p-0">
                    <div className="gallery_modal_header">
                      <img
                        className="gallery_modal_icon"
                        src="/build/Addimageframe.svg"
                        alt="img Logo"
                        width={50}
                        height={50}

                      />
                      <h5 className="gallery_modal_title ml-3">Add Media</h5>
                    </div>
                    <div className="modal_gallery_inputs">
                      <div className="file_upload_group mb-3">
                        <button
                          type="button"
                          className="choose_file_btn"
                          onClick={() =>
                            fileInputRef.current && fileInputRef.current.click()
                          }
                        >
                          Choose File
                        </button>
                        <span className="chosen_file_name">
                          {uploadImage.name || "No file chosen"}
                        </span>
                        <Form.Control
                          type="file"
                          ref={fileInputRef}
                          onChange={handleFileChange}
                          className="d-none"
                          accept=".jpg,.jpeg,.png,.webp,.pdf,.docx,.doc,.xls,.xlsx"
                        />
                      </div>
                      <Form.Label>Image Title</Form.Label>
                      <Form.Control
                        placeholder="Enter text here"
                        className="mb-3"
                        name="name"
                        value={uploadImage.name}
                        onChange={handleChange}
                      />
                      <Form.Label>Alternate Text</Form.Label>
                      {/* <Form.Control
                        placeholder="Enter text here"
                        name="alternateText"
                        value={uploadImage.alternateText}
                        onChange={handleChange}
                      />
                      <div className="mt-2 small text-muted">
                        Allowed: JPG, JPEG, PNG, WEBP, PDF, DOCX, DOC, BMP, CSV (Max: 5MB). Resolution: 1200x630px.
                      </div> */}
                    </div>
                    <div className="gallery_modal_actions">
                      <Button
                        className="gallery_modal_btn_cancel"
                        onClick={handleNotShowUpload}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="gallery_modal_btn_upload"
                        onClick={handleUpload}
                      >
                        Upload
                      </Button>
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
            </div>

            {images.length > 0 ? (
              gridView === false ? (

                <ListView
                  setSelectedPhoto={setSelectedPhoto}
                  updateSelectedCheckboxes={updateSelectedCheckboxes}
                  images={images}
                  checkedState={checkedState}
                  onPhotoClick={handlePhotoClick}
                  onSelectionCountChange={handleSelectionCountChange}
                  BASE_URL={BASE_URL}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  totalRecords={totalRecords}
                  totalPages={totalPages}
                  sortConfig={sortConfig}
                  setSortConfig={setSortConfig}
                />
              ) : (
                <div className="gallery_content_scrollable" ref={galleryRef}>
                  <GridView
                    setSelectedPhoto={setSelectedPhoto}
                    updateSelectedCheckboxes={updateSelectedCheckboxes}
                    images={images}
                    checkedState={checkedState}
                    onPhotoClick={handlePhotoClick}
                    onSelectionCountChange={handleSelectionCountChange}
                    BASE_URL={BASE_URL}
                  />
                </div>
              )
            ) : (
              <div className="empty-state-container d-flex flex-column align-items-center justify-content-center">
                <div className="mb-3">
                  <img src="/build/Addimage.svg" alt="No Media" width="180" height="100" />
                </div>
                <h4 className="fw-bold mb-2">No media uploaded yet.</h4>
                <p className="text-muted mb-4">Upload images or documents to use in your PRs.</p>
                {/* <div className="mb-4 small text-muted text-center">
                  Allowed: JPG, JPEG, PNG, WEBP, PDF, DOCX, DOC, BMP, CSV (Max: 5MB).<br />
                  Ideal for PR: 1200x630px.
                </div> */}
                <button
                  className="upload_gallery_btn px-4 py-2 mx-auto"
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                  onClick={handleShowUpload}
                >
                  <img src="/build/img/Icons/Upload.svg" alt="upload" width="16" height="16" />
                  Upload Media
                </button>
              </div>
            )}
          </div>
          {images.length > 0 && (
            <div className="image_description">
              {detailsLoading ? (
                <div className="d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '300px' }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3 text-muted">Loading details...</p>
                </div>
              ) : (
                <>
                  {numSelectedCheckboxes === 0 && (
                    <>
                      <div className="no_image">No Image to display </div>
                    </>
                  )}
                  {numSelectedCheckboxes === 1 && (
                    <>
                      <h4 className="image_name">{imageDescription.name} </h4>
                      <div className="sidebar_image_container">
                        {isImageFile((imageDescription.imgUrl || imageDescription.documentUrl)) ? (
                          <img
                            src={BASE_URL + (imageDescription.imgUrl || imageDescription.documentUrl)}
                            alt={imageDescription.name}
                            className="sidebar_preview_img"
                          />
                        ) : isOfficeFile((imageDescription.imgUrl || imageDescription.documentUrl)) ? (
                          parseInt(imageDescription.size) > 0 ? (
                            <iframe
                              src={`https://docs.google.com/viewer?url=${encodeURIComponent(BASE_URL + (imageDescription.imgUrl || imageDescription.documentUrl))}&embedded=true`}
                              width="100%"
                              height="100%"
                              title="Document Preview"
                              style={{ border: 'none', borderRadius: '8px' }}
                            />
                          ) : (
                            <div className="sidebar_file_placeholder d-flex flex-column align-items-center justify-content-center">
                              <img src="/build/img/Icons/Paperclip.svg" alt="Empty File" width="50" height="50" style={{ opacity: 0.5 }} />
                              <span className="mt-2 text-muted fw-bold">File is empty</span>
                            </div>
                          )
                        ) : (
                          <div className="sidebar_file_placeholder d-flex flex-column align-items-center justify-content-center">
                            <img src="/build/img/Icons/Paperclip.svg" alt="File" width="50" height="50" />
                            <span className="mt-2 text-uppercase fw-bold">
                              {(imageDescription.imgUrl || imageDescription.documentUrl)?.split(".").pop()}
                            </span>
                          </div>
                        )}
                      </div>

                      <div className="image_detail">
                        <div className="image_detail_row">
                          <p className="image_detail_input">Url</p>
                          <p className="image_detail_output">
                            {BASE_URL}{(imageDescription.imgUrl || imageDescription.documentUrl)}
                          </p>
                        </div>
                        <div className="image_detail_row">
                          <p className="image_detail_input"> Date Uploaded</p>
                          <p className="image_detail_output">
                            {formatDateTime(imageDescription.createdOn)}
                          </p>
                        </div>
                        <div className="image_detail_row">
                          <p className="image_detail_input">Size</p>
                          <p className="image_detail_output">
                            {(imageDescription.size / 1024).toFixed(0)} KB
                          </p>
                        </div>
                      </div>
                      <div className="gallery_details_btns">
                        <button
                          className="image_preview_btn"
                          onClick={handleShowPreview}
                        >
                          Preview
                        </button>
                        <Modal
                          show={showPreview}
                          onHide={handleNotShowPreview}
                          centered
                          className="custom_modal_preview"
                        >
                          <Modal.Body className="p-0">
                            <div className="preview_content_container d-flex align-items-center justify-content-center" style={{ minHeight: "300px", height: "50vh", padding: "10px" }}>
                              {isImageFile(selectedPhoto) ? (
                                <img
                                  className={"gallery_preview_img"}
                                  src={BASE_URL + selectedPhoto}
                                  alt="zex pr wire Logo"
                                  style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                />
                              ) : isOfficeFile(selectedPhoto) ? (
                                parseInt(imageDescription.size) > 0 ? (
                                  <iframe
                                    src={`https://docs.google.com/viewer?url=${encodeURIComponent(BASE_URL + selectedPhoto)}&embedded=true`}
                                    width="100%"
                                    height="100%"
                                    title="Document Preview"
                                    style={{ border: 'none', borderRadius: '8px' }}
                                  />
                                ) : (
                                  <div className="preview_file_placeholder d-flex flex-column align-items-center justify-content-center py-5">
                                    <img src="/build/img/Icons/Paperclip.svg" alt="Empty File" width="80" height="80" style={{ opacity: 0.5 }} />
                                    <h4 className="mt-3 text-muted fw-bold">This file is empty</h4>
                                    <p className="text-muted">No content to display for {imageDescription.name}</p>
                                  </div>
                                )
                              ) : (
                                <div className="preview_file_placeholder d-flex flex-column align-items-center justify-content-center py-5">
                                  <img src="/build/img/Icons/Paperclip.svg" alt="File" width="80" height="80" />
                                  <h4 className="mt-3 text-uppercase fw-bold">
                                    {selectedPhoto?.split(".").pop()} File
                                  </h4>
                                  <p className="text-muted">{imageDescription.name}</p>
                                </div>
                              )}
                            </div>
                            <div className="gallery_preview_btns">
                              <button
                                className="image_preview_btn"
                                onClick={handleNotShowPreview}
                              >
                                Back
                              </button>
                              <button
                                className="image_url_btn"
                                onClick={() => {
                                  copyURL("https://pr.webandapi.com" + (imageDescription.imgUrl || imageDescription.documentUrl));
                                }}
                              >
                                Copy URL
                              </button>
                              <button
                                className="image_delete_btn"
                                onClick={() => {
                                  handleShowDelete();
                                  handleNotShowPreview();
                                }}
                              >
                                <img
                                  className={"image_delete_img"}
                                  src="/build/img/Icons/Delete.png"
                                  alt="zex pr wire Logo"
                                  width={16}
                                  height={16}

                                />
                                Delete
                              </button>
                            </div>
                          </Modal.Body>
                        </Modal>
                        <button
                          className="image_url_btn"
                          onClick={() => {
                            copyURL("https://pr.webandapi.com" + (imageDescription.imgUrl || imageDescription.documentUrl));
                          }}
                        >
                          Copy URL
                        </button>
                        <button className="image_delete_btn" onClick={handleShowDelete}>
                          <img
                            className={"image_delete_img"}
                            src="/build/img/Icons/Delete.png"
                            alt="zex pr wire Logo"
                            width={16}
                            height={16}

                          />
                          Delete
                        </button>
                        <Modal
                          show={showDelete}
                          onHide={hadnleNotShowDelete}
                          centered
                          className="custom_modal"
                        >
                          <Modal.Body>
                            <div className="delete_modal_icon">
                              <img
                                className={"image_delete_img"}
                                src="/build/imageDelete.svg"
                                alt="Delete Image"
                                width={60}
                                height={60}

                              />
                            </div>
                            <div>
                              <h5 className="submit_modal_head">Delete Image</h5>
                              <p className="submit_modal_content">
                                Are you sure you want to delete this image
                                {/* {imageDescription?.galleryId
                            ? ` (ID: ${imageDescription.galleryId})`
                            : ""} */}
                                ?
                              </p>
                            </div>
                            <div className="pr_modal_btn">
                              <Button
                                className="gallery_delete_btn_cancel"
                                onClick={hadnleNotShowDelete}
                              >
                                Cancel
                              </Button>
                              <Button
                                className="image_delete_btn"
                                onClick={() => handleDelete(imageDescription.galleryId)}
                              >
                                {/* <img
                            className={"image_delete_img"}
                            src="/build/img/Icons/Delete.png"
                            alt="zex pr wire Logo"
                            width={16}
                            height={16}

                          /> */}
                                Delete
                              </Button>
                            </div>
                          </Modal.Body>
                        </Modal>
                      </div>
                    </>
                  )}
                  {numSelectedCheckboxes > 1 && (
                    <div className="multi_select_container">
                      <h4 className="image_name">Multiple Selected</h4>
                      <div
                        className="multiple_images_display d-flex flex-column align-items-center justify-content-center"
                        onClick={() => {
                          handleGridView();
                          if (galleryRef.current) {
                            galleryRef.current.scrollTo({ top: 0, behavior: "smooth" });
                          }
                        }}
                        style={{ cursor: 'pointer', minHeight: '200px', background: '#f8f9ff', borderRadius: '12px', border: '1px dashed #bbbdf0' }}
                      >
                        <div className="select_image_count_circle">
                          {numSelectedCheckboxes}
                        </div>
                        <p className="mt-3 text-muted fw-bold">Items selected</p>
                        <span className="small text-primary">Click to view in gallery</span>
                      </div>


                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
}
